import type { FC } from "react";
import { GoalDetailSolutionItem } from "web_myplann/Goals/Components/GoalDetailSolutionItem";
import { GoalDetailSolutionItemSkeleton } from "web_myplann/Goals/Components/GoalDetailSolutionItemSkeleton";
import type {
	CurrencyEnum,
	GoalPortfolioResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

type Props = {
	portfolios: GoalPortfolioResponseDTO[];
	unpinningId: number | null;
	hasFuture: boolean;
	dueYear: number;
	readOnly?: boolean;
	currencyCode?: CurrencyEnum;
	onUnpin: (portfolioId: number) => void;
	onEditAllocation: (portfolio: GoalPortfolioResponseDTO) => void;
	onLockedAction: (() => void) | null;
};

export const GoalDetailSolutionList: FC<Props> = ({
	portfolios,
	unpinningId,
	hasFuture,
	dueYear,
	readOnly,
	currencyCode,
	onUnpin,
	onEditAllocation,
	onLockedAction,
}) => (
	<>
		{portfolios.map((portfolio, i) =>
			portfolio.portfolioId === unpinningId ? (
				<GoalDetailSolutionItemSkeleton
					key={portfolio.portfolioId}
					hasDivider={i < portfolios.length - 1}
				/>
			) : (
				<GoalDetailSolutionItem
					key={portfolio.portfolioId}
					portfolio={portfolio}
					hasDivider={i < portfolios.length - 1 || hasFuture}
					dueYear={dueYear}
					readOnly={readOnly}
					currencyCode={currencyCode}
					onUnpin={onUnpin}
					onEditAllocation={onEditAllocation}
					onLockedAction={onLockedAction}
				/>
			),
		)}
	</>
);
